import { all } from '@awesome.me/kit-4a0384d848/icons'
import {
  fromFontAwesome,
  proIconFallbacks,
  registerIcons,
} from '@lilara/ui-web'

export function registerLilaraIcons(): void {
  registerIcons(proIconFallbacks)
  registerIcons(fromFontAwesome(all))
}
